import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ApiErrorType } from "src/model/enum/enumApiErrorType";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { AppSettings } from "../components/shared-components/class/general-classes/app-settings";
import { GenericApiData } from "../components/shared-components/class/general-classes/generic-api-data";
import { LoaderService } from "./loader.service";
import { MqttClientService } from "./mqtt-client.service";
import { Communication } from "src/model/class/general classes/communication";
import { Communications_Kind } from "src/model/enum/enumCommunication";

@Injectable({
  providedIn: "root",
})
export class CommunicationService implements OnDestroy, iEvent {
  /**Flag property; if the service ha foud an error in the last API call needed for get the Accesses-Openable-By-User-list from the server, it is set to TRUE;
   * otherwise, it is set to FALSE.
   */
  private _isErrorInAccessesOpenableByUserAPIRequest: boolean = false;

  private _isAccessesOpenableByUserAPIRequestNotSupported: boolean = false;

  /**
   * Flag property; if the request to server for the list of environments which are accessible by the current user has been correctly carried out, it is set to FALSE.
   * This makes impossible to ask again for these data (at least until next logout/login).
   */
  private _isFirstTimeToAskAccessesOpenableByUser: boolean = true;

  /**Flag property; if the service ha foud an error in the last API call needed for get the environments-list from the server, it is set to TRUE;
   * otherwise, it is set to FALSE.
   */
  private _isErrorInEnvironmentListAPIRequest: boolean = false;

  get isErrorInEnvironmentListAPIRequest(): boolean {
    return this._isErrorInEnvironmentListAPIRequest;
  }

  get isErrorInAccessesOpenableByUserAPIRequest(): boolean {
    return this._isErrorInAccessesOpenableByUserAPIRequest;
  }

  /*
  get isAccessesOpenableByUserAPIRequestNotSupported(): boolean {
    return this._isAccessesOpenableByUserAPIRequestNotSupported;
  }
  */
  get isFirstTimeToAskAccessesOpenableByUser(): boolean {
    return this._isFirstTimeToAskAccessesOpenableByUser;
  }

  _eventSubscriptions: Array<Subscription> = null;

  public needToInitialize: boolean = true;

  constructor(
    private eventService: EventService,
    private http: HttpClient,
    private _loaderController: LoaderService,
    private mqttService: MqttClientService,
    private _eventService: EventService
  ) {
    this.subscribeEvents();

    this._isFirstTimeToAskAccessesOpenableByUser = true;
  }

  /** Destroy event service */
  ngOnDestroy() {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    /** Operation performed on logout */
    this._eventSubscriptions.push(
      this.eventService.OnMakeLogout.subscribe(() => {
        this.needToInitialize = true;

        this._isFirstTimeToAskAccessesOpenableByUser = true;
      })
    );

    this._eventSubscriptions.push(
      this.eventService.OnLoginPlantDid.subscribe(() => {
        this._isFirstTimeToAskAccessesOpenableByUser = true;
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   *  Initialize public observable list trasmission: it should be call in the costructor of all component/page that you need.
   */
  public Init() {
    if (this.needToInitialize) {
      this.needToInitialize = false;
    }
  }

  /**
   * Reload service data (es. in case of error)
   */
  public reloadServiceData() {
    this.needToInitialize = true;

    this.Init();
  }

  /**
   * Get all the communication with specific parameters
   */
  public async GetCommunication(
    kind: Communications_Kind,
    topRow: number,
    startDate: string,
    endDate: string,
    idUser: string
  ): Promise<Array<Communication>> {
    // Initialize Params Object
    let params = new HttpParams();
    if (kind != Communications_Kind.Unknown)
      params = params.append("kind", kind);
    if (topRow > 0) params = params.append("topRow", topRow);
    if (startDate != "") params = params.append("startDate", startDate);
    if (endDate != "") params = params.append("endDate", endDate);
    if (idUser != "") params = params.append("idUser", idUser);
    return this.http
      .get<Array<Communication>>(
        environment.httpServerRoot + AppSettings.API_URL_COMMUNICATION,
        { params: params }
      )
      .toPromise();
  }
}
